export const getClientFreespinSubType = freeSpin =>
  freeSpin?.freeSpin?.freeSpinSubType ?? freeSpin?.freeSpinSubType ?? null;

// server expirationTime when present; otherwise create time + time to use
export const resolveFreespinExpirationMs = freeSpin => {
  if (freeSpin?.expirationTime != null) {
    return freeSpin.expirationTime;
  }

  const createTime = freeSpin?.createTime;
  const timeToUse = freeSpin?.freeSpin?.timeToUse;

  if (createTime != null && timeToUse != null) {
    return createTime + timeToUse;
  }

  return createTime ?? null;
};
